import { BroadcastChannel } from 'broadcast-channel'
import { useEffect, useState } from 'react'

declare type Message = {
  userId: string
  entityID?: string
  payload: any
}

export const LOGOUT_SIGNAL_KEY = 'logoutSignal'

export declare type LogoutSignal = {
  userId: string
  entityID?: string
  at: number
}

export const subscribeLogoutSignal = (
  handler: (signal: LogoutSignal) => void
) => {
  const onStorage = (event: StorageEvent) => {
    if (event.key !== LOGOUT_SIGNAL_KEY || !event.newValue) return
    try {
      handler(JSON.parse(event.newValue))
    } catch (e) {
      // ignore malformed signals
    }
  }
  window.addEventListener('storage', onStorage)
  return () => window.removeEventListener('storage', onStorage)
}

export const useBroadcastChannel = () => {
  const [userChannel] = useState<BroadcastChannel<Message>>(
    () => new BroadcastChannel('user')
  )

  useEffect(() => {
    return () => {
      userChannel.close()
    }
  }, [userChannel])

  const signOut = (userId: string, entityID?: string) => {
    userChannel.postMessage({
      userId: userId, // If the user opened your app in multi-tabs and signed-in with multi accounts, you need to put the userId here to identify which account has signed out exactly
      entityID,
      payload: {
        type: 'SIGN_OUT',
      },
    })
    localStorage.setItem(
      LOGOUT_SIGNAL_KEY,
      JSON.stringify({ userId, entityID, at: Date.now() })
    )
  }

  return {
    userChannel,
    signOut,
  }
}
